export default "__VITE_ASSET__48e6375d__"